
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

/** component to show modal dialog. this component by itself is the modal dialog */
@Component({
    selector: 'app-modal',
    imports: [
    FormsModule
],
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css']
})
export class AppModalComponent {
  @Input() isVisible: boolean = false;
  @Input() title: string = '';
  @Input() showCloseButton: boolean = true;
  @Output() closeModal = new EventEmitter<void>();
  @Output() userKeydown = new EventEmitter<KeyboardEvent>();


  onClose() {
    this.closeModal.emit();
  }

  /**
   * backdrop => outside the dialog window
   * @param event
   */
  onBackdropClick(event: MouseEvent) {
    // Close modal when clicking on backdrop
    if (event.target === event.currentTarget) {
      this.onClose();
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    this.userKeydown.next(event);
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    this.onClose();
  }
}
